import { useMemo } from 'react';

let counter = 1;

export function useDefaultId(id?: string) {
	return id || 'element-default-id-' + useMemo(() => counter++, []).toString();
}
